export default "__VITE_ASSET__FBGYWYho__"